import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../images/actions";
import surveyAssetActions from "../../../assetSurveyProject/actions";
import Draggable from "react-draggable";
import { toTitleCase, showAlert as showAlertUtil } from "../../../../config/utils";
import qs from "query-string";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";

const ImageCaptionEditModal = ({
    onClose,
    selectedImages,
    refreshImageList,
    handleClearAll,
    isSurveyAssetImage = false,
    isMobileRecommendation = false,
    section,
    isMobRecom = false,
    isMobileRegularRecom = false
}) => {
    const [caption, setCaption] = useState("");
    const [error, setError] = useState("");
    const [isChecked, setIsChecked] = useState(false);

    const updateImageRef = useRef(null);
    const textareaRef = useRef(null);
    const query = qs.parse(useLocation()?.search);
    const { id } = useParams();

    const { imageUpdateGlobalResponse } = useSelector(state => state.imageReducer);
    const { updateSurveyAssetImageResponse, updateSurveyAssetImageResponseLoading } = useSelector(state => state.assetSurveyProjectReducer);

    const dispatch = useDispatch();
    const handleCheckboxChange = event => {
        setIsChecked(event.target.checked);
    };

    const handleCaptionChange = e => {
        setError("");
        const textarea = e?.target;
        const cursorPosition = textarea?.selectionStart;
        const newValue = toTitleCase(textarea.value);
        setCaption(newValue);

        requestAnimationFrame(() => {
            if (textareaRef?.current) {
                textareaRef.current.selectionStart = cursorPosition;
                textareaRef.current.selectionEnd = cursorPosition;
            }
        });
    };

    const selectedImagesIds = selectedImages?.map(({ id }) => id);

    const onUpdateCaption = () => {
        if ((caption || "")?.trim() === "") {
            setError("Caption is required.");
            return;
        }

        setError("");
        if (isSurveyAssetImage) {
            dispatch(
                surveyAssetActions.updateSurveyAssetImageGlobal(
                    {
                        image_ids: selectedImagesIds,
                        description: caption,
                        update_global_caption: isChecked,
                        ...(isMobRecom ? { mobile_recom_id: id ?? query?.s_id } : {}),
                        ...(isMobileRegularRecom ? { view_from: "recommendation" } : {})
                    },
                    isMobileRecommendation || isMobRecom
                )
            );
        } else dispatch(actions.updateImageGlobal({ image_ids: selectedImagesIds, description: caption, update_global_caption: isChecked }, section));
        updateImageRef.current = true;
    };

    const getCommonDescription = () => {
        const descriptions = selectedImages?.map(({ description }) => description);
        const uniqueDescriptions = [...new Set(descriptions)];
        return uniqueDescriptions?.length === 1 ? uniqueDescriptions[0] : "";
    };

    useEffect(() => {
        const commonDescription = getCommonDescription();
        setCaption(commonDescription);
    }, [selectedImages]);

    useEffect(() => {
        if (textareaRef?.current) {
            textareaRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (imageUpdateGlobalResponse.success && updateImageRef?.current) {
            alertFunction("Image Caption Updated Successfully");
            updateImageRef.current = false;
            onClose();
            refreshImageList();
            handleClearAll();
        } else if ((imageUpdateGlobalResponse?.error || imageUpdateGlobalResponse?.detail) && updateImageRef?.current) {
            alertFunction(
                typeof imageUpdateGlobalResponse?.detail === "string"
                    ? imageUpdateGlobalResponse?.detail
                    : imageUpdateGlobalResponse?.error
            );
            updateImageRef.current = false;
        }
    }, [imageUpdateGlobalResponse]);

    useEffect(() => {
        if (updateSurveyAssetImageResponse?.success && updateImageRef?.current) {
            alertFunction("Image Caption Updated Successfully");
            updateImageRef.current = false;
            onClose();
            refreshImageList();
            handleClearAll();
        } else if ((updateSurveyAssetImageResponse?.error || updateSurveyAssetImageResponse?.detail) && updateImageRef?.current) {
            alertFunction(
                typeof updateSurveyAssetImageResponse?.detail === "string"
                    ? updateSurveyAssetImageResponse?.detail
                    : updateSurveyAssetImageResponse?.error
            );
            updateImageRef.current = false;
        }
    }, [updateSurveyAssetImageResponse]);

    const alertFunction = message => {
        if (message !== "") {
            showAlertUtil(message);
        }
    };

    return (
        <div id="modalId" className="modal modal-region modal-img-magamnt modal-caption" style={{ display: "block" }}>
            <Draggable cancel=".not-draggable" handle=".draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <button type="button" className="close not-draggable" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                            <span aria-hidden="true">
                                <img src="/img/close.svg" alt="" />
                            </span>
                        </button>
                        <div className="modal-header draggable">
                            <div class="heading position-relative">
                                <h5 className="modal-title"> Edit Caption</h5>{" "}
                            </div>
                        </div>

                        <div className="modal-body region-otr core-rpt-dt-mod sm-chart-upload cursor-default">
                            <div className="col-md-12 main-sec">
                                <span className="sel-chart-badge"> Selected Images : {selectedImages?.length || "-"}</span>
                                <div className="form-row">
                                    <div className="form-group col-12 mb-4">
                                        <label>Caption</label>
                                        <textarea
                                            ref={textareaRef}
                                            className={` ${error ? "error-border" : ""} form-control textarea`}
                                            value={caption}
                                            onChange={handleCaptionChange}
                                        ></textarea>
                                    </div>
                                    {error && <span className="errorMessage mb-3">{error}</span>}
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-12 mb-4">
                                        <label class="container-check checkmark-caption ">
                                            <input className="cursor-pointer" type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />{" "}
                                            <span class="checkmark checkmark-top"></span> If checked, the caption entered here will also be applied
                                            directly to these images in Image Management module
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="btnOtr">
                                <button type="button" className="btn btn-secondary btnClr not-draggable" onClick={onClose}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    disabled={imageUpdateGlobalResponse?.isLoading}
                                    className="btn btn-primary btnRgion ml-2"
                                    onClick={onUpdateCaption}
                                >
                                    {imageUpdateGlobalResponse?.isLoading || updateSurveyAssetImageResponseLoading ? (
                                        <div className="spinner-border text-white spinner-border-sm" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    ) : (
                                        "Update"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default ImageCaptionEditModal;
